import { React, useState, useEffect, useRef } from "react";
import Swal from "sweetalert2";
import api from "../../Utils/api";
import AgGridComponent from "../../Components/Common/AgGridComponent";
import * as XLSX from "xlsx";
import UserSetting from "../../UserSettings.json";
import {
  getCurrentDateTime,
  formatDate
  
} from "../../Utils/commonfunctions";
//import _ from "lodash";
import Spinner from "react-bootstrap/Spinner";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./GetMonthlyProductionForecast.css";
const GetMonthlyProductionForecastReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showTable, setShowTable] = useState(false);
  const [groupSummeryData, setSummeryData] = useState([]);
  const [groupDetailData, setDetailData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const StartDateRef = useRef(null);
  

const [summary, setSummary] = useState([]);
const [details, setDetails] = useState([]);
  useEffect(() => {
    if (StartDateRef.current) {
      StartDateRef.current.focus();
    }
  }, []);


  useEffect(() => {
     setStartDate(getCurrentDateTime);
     setEndDate(getCurrentDateTime);
     setSummeryData([]);
     //setDetailData([]);
     
   }, []);
  const ClearData = () => {
    setShowTable(false);
    setEndDate(getCurrentDateTime);
    setStartDate(getCurrentDateTime);
    
    
  };
   
  const PrintMachineProductionReport = () => {
    debugger;
    setIsLoading(true); // Show loader

    if (startDate === "" || startDate === null) {
      return Swal.fire("Error", "Please Select Start Date", "error");
    }

    if (endDate === "" || endDate === null) {
      return Swal.fire("Error", "Please Select End Date", "error");
    }
 

    setShowTable(false);
    setSummeryData([]);
     //setDetailData([]);
    const formattedStartDate = formatDate(startDate);
    const formattedEndDate = formatDate(endDate);

    api
    .get(
        `Report/PrintGetMonthlyProductionForecast?START_DATE=${formattedStartDate}&END_DATE=${formattedEndDate} `
    )
     
   .then((result) => {

    const apiData = result.data?.data || {};

    const summary = apiData.summary || [];
    //const details = apiData.detail || [];
   // ==========================================
    // SAVE SUMMARY
    // ==========================================

    setSummary(summary);
    //setSummeryData(sortedSummary);


    // ==========================================
    // SAVE ALL DETAILS
    // ==========================================

    // setDetails(details);
    // setDetailData(details);


    // ==========================================
    // SHOW REPORT
    // ==========================================

    setShowTable(
        setSummary.length > 0 ||
        details.length > 0
    );

})
    .catch((error) => {
        console.log(error);

        setSummeryData([]);
        //setDetailData([]);
        setShowTable(false);

        Swal.fire(
            "Error",
            "Unable to get Monthly Production Forecast Report",
            "error"
        );
    })
    .finally(() => {
        setIsLoading(false);
    });
  };


  const columnDefs = [
    {
      headerName: "SrNo",
      field: "srNo",
      width: "80px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      autoHeaderHeight: true,
      
    },
    //  {
    //   headerName: "Machine Start Date",
    //   field: "machineStartDate",
    //   flex: 1,
    //   minWidth: 100,
    //   cellStyle: { textAlign: "left" },
    //   valueFormatter: (params) => {
    //     if (params.value) {
    //       const date = new Date(params.value);
    //       const formattedDate = date.toLocaleDateString("en-IN", {
    //         day: "2-digit",
    //         month: "2-digit",
    //         year: "numeric",
    //         hour: "2-digit",
    //         minute: "2-digit",
    //         hour12: true,
    //       });
    //       return formattedDate;
    //     }
    //     return "";
    //   },
    // },
    // {
    //   headerName: "Machine End Date",
    //   field: "machineEndDate",
    //   flex: 1,
    //   minWidth: 100,
    //   cellStyle: { textAlign: "left" },
    //   valueFormatter: (params) => {
    //     if (params.value) {
    //       const date = new Date(params.value);
    //       const formattedDate = date.toLocaleDateString("en-IN", {
    //         day: "2-digit",
    //         month: "2-digit",
    //         year: "numeric",
    //         hour: "2-digit",
    //         minute: "2-digit",
    //         hour12: true,
    //       });
    //       return formattedDate;
    //     }
    //     return "";
    //   },
    // },
     
    {
      headerName: "RowLabels",
      field: "rowLabels",
      width: "100px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      autoHeaderHeight: true,
      
    },
    
    {
      headerName: "AverageBroken",
      field: "averageBroken",
      wrapHeaderText: true,
      width: "110px",
      autoHeaderHeight: true,
      wrapText: false,
      autoHeight: false,
      sortable: true,
      filter: true,
      autoHeaderHeight: true,
      cellStyle: { textAlign: "left" },
    
    },
    {
      headerName: "SumMachineHours",
      field: "sumMachineHours",
      wrapHeaderText: true,
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
    },
    {
      headerName: "AveragePerHrGrowthRate",
      field: "averagePerHrGrowthRate",
      wrapHeaderText: true,
      width: "130px",
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "SumSeedWeight",
      field: "sumSeedWeight",
      wrapHeaderText: true,
      width: "130px",
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      cellStyle: { textAlign: "left" },
    },
    
    {
      headerName: "SumNetWeight",
      field: "sumNetWeight",
      wrapHeaderText: true,
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      
    },
    {
      headerName: "SumGrowWeight",
      field: "sumGrowWeight",
      wrapHeaderText: true,
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      
    },
    {
      headerName: "EstimatedWastage20%",
      field: "estimatedWastage20Percent",
      wrapHeaderText: true,
      width: "160px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      
    },
    {
      headerName: "EstimatedAfterWastage",
      field: "estimatedAfterWastage",
      wrapHeaderText: true,
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      
    },
    
    {
      headerName: "NetEstimatedProduction",
      field: "netEstimatedProduction",
      wrapHeaderText: true,
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      
    },
    {
      headerName: "EstimatedProductionHrGrowthRate",
      field: "estimatedProductionHrGrowthRate",
      wrapHeaderText: true,
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      
    },
    {
      headerName: "MonthlyEstimatedProduction (690 hrs)",
      field: "monthlyEstimatedProduction",
      wrapHeaderText: true,
      width: "150px",
      cellStyle: { textAlign: "left" },
      sortable: true,
      filter: true,
      wrapText: false,
      autoHeight: false,
      autoHeaderHeight: true,
      
    },
    
    
    
    
   ];
  

  const exportToExcel = () => {
    if (groupSummeryData.length > 0) {
      const params = {
        fileName: "Machine_Production-Data.xlsx",
        sheetName: "Data",
      };

      const excelData = [];
      const columns = [];

      // Extract column headers
      columnDefs.forEach((column) => {
        columns.push(column.headerName);
      });

      excelData.push(columns);

      // Add data rows
      groupSummeryData.forEach((row) => {
        const rowData = [];
        columnDefs.forEach((column) => {
          rowData.push(row[column.field]);
        });
        excelData.push(rowData);
      });

      const totalRow = [ ];
      excelData.push(totalRow);

      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, params.sheetName);

      XLSX.writeFile(wb, params.fileName);
    }
  };
 const formatReportDate = (value) => {

    if (!value) {
        return "";
    }

    const date = new Date(value);

    if (isNaN(date.getTime())) {
        return value;
    }

    return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
    });
};
  const exportToExcelDetail = () => {
    if (groupSummeryData.length > 0) {
      const params = {
        fileName: "MonthlyProductionForcast_Report-Data.xlsx",
        sheetName: "Data",
      };

      const excelData = [];
      const columns = [];

      // Extract column headers
      columnDefs.forEach((column) => {
        columns.push(column.headerName);
      });

      excelData.push(columns);

      // Add data rows
      groupDetailData.forEach((row) => {
        const rowData = [];
        columnDefs.forEach((column) => {
          rowData.push(row[column.field]);
        });
        excelData.push(rowData);
      });

      // Add total row
       const totalRow = [
      
       ];
      excelData.push(totalRow);

      const ws = XLSX.utils.aoa_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, params.sheetName);

      XLSX.writeFile(wb, params.fileName);
    }
  };

  
 debugger
   return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header">
          <span>Monthly Production Forcast REPORT</span>
        </div>
        <div className="card-body">
          <div className="row col-md-12 mb-3">
            <div className="col-md-2 col-sm-2 col-lg-2">
              <strong htmlFor="startDate">Start Date:</strong>
              <input
                ref={StartDateRef}
                type="datetime-local"
                className="form-control"
                id="startDate"
                placeholder="Enter Machine Start Time"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </div>
            <div className="col-md-2 col-sm-2 col-lg-2">
              <strong htmlFor="endDate">End Date:</strong>
              <input
                type="datetime-local"
                className="form-control"
                id="endDate"
                placeholder="Enter Machine Start Time"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </div>
            
            <div className="col-md-2 col-sm-2 col-lg-2">
              <br />
              <button
                type="submit"
                className="btn btn-primary"
                onClick={PrintMachineProductionReport}
              >
                <i class="fa fa-search"></i>
                {"  "}
                Search
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                onClick={ClearData}
                style={{ marginLeft: "10px" }}
              >
                <i class="fa fa-refresh"></i>
                {"  "}
                Clear
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        {isLoading && (
          <>
            <div className="overlay"></div>
            <div className="overlay-content text-center">
              <Spinner animation="" variant="primary">
                <span class="loader"></span>
              </Spinner>
            </div>
          </>
        )}

        <div className="card-header">
          <span>Monthly Production Forecast (Based on Estimated 7-Day Machine Operation of 22 Machine)</span>
        </div>
        <div className="card-body">
          {showTable ? (
            <div style={{ display: "flex", justifyContent: "end" }}>
              <button className="btn btn-primary mb-2" onClick={exportToExcel}>
                <i class="fa fa-file-excel"></i> Export to Excel
              </button>


              {details.length > 0 && (
                  <button
                      className="btn btn-success mb-2"
                      onClick={() => window.print()}
                      style={{ marginLeft: "10px" }}
                  >
                      <i className="fa fa-print"></i>{" "}
                      Print Report
                  </button>
              )}
            </div>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <strong>Data Not Found</strong>
            </div>
          )}
          {showTable && (
            <>
              <AgGridComponent 
                    columnDefs={columnDefs}
                    rowData={summary}
                    paginationPageSize={100}
                    height="80vh"
                />
            </>
          )}
        </div>
      </div>

        

       <div className="card">

    {isLoading && (
        <>
            <div className="overlay"></div>

            <div className="overlay-content text-center">

                <Spinner animation="" variant="primary">
                    <span className="loader"></span>
                </Spinner>

            </div>
        </>
    )}


   

</div>

   
    </>
  );
};

export default GetMonthlyProductionForecastReport ;